import React, { useEffect, useState } from 'react';

type ToggleSwitchProps = {
  onValueChange: (value: string) => void;
  values: Array<{ value: string; label: string; dataLayer?: string }>;
  defaultValue?: string;
};

function ToggleSwitch({
  onValueChange,
  values,
  defaultValue
}: ToggleSwitchProps) {
  const [value, setValue] = useState<string>(defaultValue || '');

  const handleClick = (val: string) => {
    if (val !== value) {
      setValue(val);
      onValueChange(val);
    }
  };

  useEffect(() => {
    if (defaultValue && defaultValue !== value) {
      handleClick(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className="toggle-switch">
      {values.map((val, index) => (
        <button
          disabled={val.value === value}
          key={index}
          className={`toggle-switch__button ${
            val.value === value ? 'active' : ''
          }`}
          onClick={() => handleClick(val.value)}
          data-layer={[val.dataLayer]}
        >
          {val.label}
        </button>
      ))}
    </div>
  );
}

export default ToggleSwitch;
